import {
  HistoricalFactRow,
  HistoricalImportRow,
} from './bieHistorical.models';

export const normalizeHistoricalImportRow = (r: any): HistoricalImportRow => ({
  rid: Number(r.rid ?? r.recid ?? r.id),
  rix: r.rix ?? r.recix ?? null,
  code: r.shc ?? r.shortcode ?? '',
  name: r.nam ?? r.recname ?? '',
  description: r.dsc ?? r.description ?? '',
  sourceid: r.soi ?? r.sourceid ?? null,
  sourcecode: r.soc ?? r.sourcecode ?? '',
  sourcename: r.son ?? r.sourcename ?? '',
  scenarioid: r.sci ?? r.scenarioid ?? null,
  scenariocode: r.scc ?? r.scenariocode ?? '',
  scenarioname: r.scn ?? r.scenarioname ?? '',
  trackid: r.tri ?? r.trackid ?? '',
  filename: r.fnm ?? r.filename ?? r.nam ?? '',
  importdate: r.dcd ?? r.importdate ?? r.created ?? null,
  recordcount: Number(r.trc ?? r.recordcount ?? 0),
  validcount: Number(r.vrc ?? r.validcount ?? 0),
  warningcount: Number(r.wrc ?? r.warningcount ?? 0),
  errorcount: Number(r.crc ?? r.errorcount ?? 0),
  failedcount: Number(r.frc ?? r.failedcount ?? 0),
  statecode: r.ssc ?? r.statecode ?? '',
  statename: r.ssn ?? r.statename ?? '',
  status: Number(r.ast ?? r.sts ?? r.status ?? 1),
  raw: r,
});

export const normalizeHistoricalFactRow = (r: any): HistoricalFactRow => ({
  rid: r.rid ?? r.recid ?? r.id ?? r.rix ?? r.recix,
  rix: r.rix ?? r.recix ?? null,
  importid: r.imi ?? r.importid ?? null,
  trackid: r.tri ?? r.trackid ?? '',
  metriccode: r.mtc ?? r.metriccode ?? r.drc ?? '',
  metricname: r.mtn ?? r.metricname ?? r.drn ?? '',
  productcode: r.prc ?? r.productcode ?? r.enc ?? '',
  productname: r.prn ?? r.productname ?? r.enn ?? '',
  periodcode: r.pec ?? r.periodcode ?? r.psh ?? '',
  periodname: r.pen ?? r.periodname ?? r.prn ?? '',
  quantity: Number(r.qty ?? r.quantity ?? 0),
  unitprice: Number(r.upr ?? r.unitprice ?? 0),
  amount: Number(r.amt ?? r.amount ?? 0),
  sourcecode: r.soc ?? r.sourcecode ?? '',
  statecode: r.ssc ?? r.statecode ?? '',
  statename: r.ssn ?? r.statename ?? '',
  remarks: r.rmk ?? r.remarks ?? r.dsc ?? '',
  status: Number(r.ast ?? r.sts ?? r.status ?? 1),
  raw: r,
});
